import { useEffect, useMemo, useState } from "react";

export const FoundingMembersRibbon = ({ activeCount = 0, availableCount = 0, members = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeMembers = useMemo(() => members.filter((member) => member?.name), [members]);

  useEffect(() => {
    if (activeMembers.length <= 1) return undefined;
    const interval = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % activeMembers.length);
    }, 2200);
    return () => window.clearInterval(interval);
  }, [activeMembers]);

  if (!activeMembers.length) return null;

  const currentMember = activeMembers[activeIndex] || activeMembers[0];

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-[26px] border border-[#D4AF37]/26 bg-[linear-gradient(120deg,#001935_0%,#0a2647_52%,#15355d_100%)] px-5 py-4 text-[#F6F1E9] shadow-[0_20px_55px_rgba(0,25,53,0.12)]" data-testid="founding-members-ribbon">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#F5D98C]">Recently Activated Founding Members</p>
        <p className="mt-2 text-lg font-semibold" data-testid="founding-members-ribbon-active-name">{currentMember.name}</p>
      </div>
      <div className="flex flex-wrap items-center gap-3 text-xs font-bold uppercase tracking-[0.18em] text-[#F5D98C]">
        <span className="rounded-full border border-white/10 bg-white/5 px-4 py-2" data-testid="founding-members-ribbon-active-count">{activeCount} active seats</span>
        <span className="rounded-full border border-white/10 bg-white/5 px-4 py-2" data-testid="founding-members-ribbon-available-count">{availableCount} remaining</span>
      </div>
    </div>
  );
};